import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Confirmation = () => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Trigger entrance animation
    const t = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(t);
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(160deg, #071520 0%, #0a1e2e 35%, #071018 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px 16px",
        boxSizing: "border-box",
      }}
    >
      {/* Animated card */}
      <div
        style={{
          width: "100%",
          maxWidth: "480px",
          background: "#ffffff",
          borderRadius: "20px",
          border: "1px solid rgba(64,190,180,0.35)",
          boxShadow: "0 24px 64px rgba(0,0,0,0.45), 0 0 40px rgba(64,190,180,0.1)",
          overflow: "hidden",
          opacity: visible ? 1 : 0,
          transform: visible ? "translateY(0) scale(1)" : "translateY(24px) scale(0.97)",
          transition: "opacity 0.45s ease, transform 0.45s ease",
        }}
      >
        {/* Top teal accent bar */}
        <div style={{ height: "5px", background: "linear-gradient(90deg, #40BEB4, #2a9d93, #40BEB4)" }} />

        <div style={{ padding: "48px 40px 40px", textAlign: "center" }}>

          {/* Animated success ring */}
          <div style={{ display: "flex", justifyContent: "center", marginBottom: "24px" }}>
            <div
              style={{
                position: "relative",
                width: "88px",
                height: "88px",
              }}
            >
              {/* Outer pulse ring */}
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  borderRadius: "50%",
                  background: "rgba(64,190,180,0.08)",
                  border: "2px solid rgba(64,190,180,0.2)",
                  animation: visible ? "pulse-ring 2s ease-in-out infinite" : "none",
                }}
              />
              {/* Inner circle */}
              <div
                style={{
                  position: "absolute",
                  inset: "10px",
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, rgba(64,190,180,0.15), rgba(64,190,180,0.25))",
                  border: "2px solid rgba(64,190,180,0.5)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <svg
                  style={{ width: "28px", height: "28px", color: "#40BEB4" }}
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="3"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </div>
            </div>
          </div>

          {/* Title */}
          <h2
            style={{
              fontSize: "26px",
              fontWeight: "800",
              color: "#1a1a2e",
              marginBottom: "10px",
              letterSpacing: "-0.5px",
            }}
          >
            Submission{" "}
            <span style={{ color: "#40BEB4" }}>Successful!</span>
          </h2>

          {/* Divider */}
          <div
            style={{
              width: "60px",
              height: "3px",
              background: "linear-gradient(90deg, #40BEB4, #2a9d93)",
              borderRadius: "2px",
              margin: "0 auto 20px",
            }}
          />

          {/* Body text */}
          <p
            style={{
              color: "#6b7280",
              fontSize: "14px",
              lineHeight: "1.7",
              marginBottom: "12px",
            }}
          >
            Your Video KYC details have been submitted successfully.
          </p>
          <p
            style={{
              color: "#9ca3af",
              fontSize: "13px",
              lineHeight: "1.6",
              marginBottom: "36px",
            }}
          >
            Our team will review the information and proceed further. You'll be notified once the verification is complete.
          </p>

          {/* CTA Button */}
          <button
            onClick={() => navigate("/home")}
            style={{
              width: "100%",
              padding: "14px",
              borderRadius: "12px",
              background: "linear-gradient(135deg, #40BEB4, #2a9d93)",
              color: "#fff",
              fontWeight: "700",
              fontSize: "15px",
              letterSpacing: "0.5px",
              border: "none",
              cursor: "pointer",
              boxShadow: "0 6px 20px rgba(64,190,180,0.35)",
              transition: "opacity 0.2s, transform 0.2s",
            }}
            onMouseEnter={e => { e.currentTarget.style.opacity = "0.9"; e.currentTarget.style.transform = "translateY(-1px)"; }}
            onMouseLeave={e => { e.currentTarget.style.opacity = "1"; e.currentTarget.style.transform = "translateY(0)"; }}
          >
            Back to Home
          </button>
        </div>

        {/* Bottom tint strip */}
        <div
          style={{
            background: "linear-gradient(90deg, rgba(64,190,180,0.04), rgba(64,190,180,0.08), rgba(64,190,180,0.04))",
            padding: "14px",
            textAlign: "center",
          }}
        >
          <span style={{ fontSize: "11px", color: "#9ca3af" }}>
            © Advitiya Labs · Video KYC System
          </span>
        </div>
      </div>

      <style>{`
        @keyframes pulse-ring {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.06); opacity: 0.7; }
        }
        @keyframes blink {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.3; }
        }
      `}</style>
    </div>
  );
};

export default Confirmation;
